module.exports = __webpack_public_path__ + "img/youtube.7cc578da.svg";